export default "__VITE_ASSET__DoHI0IfT__"